
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeName } from '@/utils/storage';

export const useStarUI = (initialTab: string = 'tasks') => {
  const location = useLocation();
  
  const [editMode, setEditMode] = useState(false); // Remove persistence
  const [activeTab, setActiveTab] = useState(initialTab === 'stats' ? 'trophies' : initialTab);
  const [showResetDialog, setShowResetDialog] = useState(false);
  const [animateStars, setAnimateStars] = useState(false);
  const [showGiantStar, setShowGiantStar] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [adsEnabled, setAdsEnabled] = useState(() => {
    if (typeof window !== 'undefined') {
      const storedValue = localStorage.getItem('adsEnabled');
      return storedValue !== 'false';
    }
    return true;
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('adsEnabled', String(adsEnabled));
    }
  }, [adsEnabled]);

  // Handle edit mode restoration when returning from edit pages
  useEffect(() => {
    const state = location.state as { keepEditMode?: boolean } | null;
    if (state?.keepEditMode === true) {
      setEditMode(true);
      // Clear the state to prevent re-triggering
      window.history.replaceState({}, '', location.pathname);
    }
  }, [location.state]);

  const handleToggleEditMode = () => {
    setEditMode(prev => !prev);
  };

  const handleGiantStarAnimationComplete = () => {
    setShowGiantStar(false);
    setIsAnimating(false);
  };

  return {
    editMode,
    activeTab,
    showResetDialog,
    animateStars,
    showGiantStar,
    isAnimating,
    adsEnabled,
    setEditMode,
    setActiveTab,
    setShowResetDialog,
    setAnimateStars,
    setShowGiantStar,
    setIsAnimating,
    setAdsEnabled,
    handleToggleEditMode,
    handleGiantStarAnimationComplete
  };
};
